import { addError } from './addError';
import get from 'lodash/get';

export function fetchCampaignsRulesets({ commit, getters, rootGetters }, campaigns = []) {
	return new Promise((resolve) => {
		if (!rootGetters.connected) {
			return resolve();
		}

		const update = (campaignId, value, valueType = 'array') => {
			const key = 'rulesets';
			commit('updateCampaignValue', { campaignId, key, value, valueType });
		};

		const campaignIds = campaigns
			.map((id) => {
				const campaign = getters.getCampaign(id);
				const campaignId = get(campaign, 'id');

				if (!campaignId) {
					update(campaignId, new Error(`Cannot find campaign for this id: ${id}`), 'object');
					return false;
				}

				// Already fetched or fetching? Don't do again.
				if (
					rootGetters.isFetched(`c-rulesets-${campaignId}`) ||
					rootGetters.isFetching(`c-rulesets-${campaignId}`)
				) {
					return false;
				}

				// Nope, we don't do legacy campaigns.
				if (get(campaign, 'is_legacy')) {
					return false;
				}

				// If we've already got rulesets, don't fetch.
				if (0 < get(campaign, 'rulesets.length', 0)) {
					return false;
				}

				return get(campaign, 'id');
			})
			.filter((id) => !!id);

		// Nothing to fetch.
		if (!campaignIds.length) {
			return resolve();
		}

		campaignIds.forEach((campaignId) => {
			commit('fetching', `c-rulesets-${campaignId}`, { root: true });
		});

		this._vm.$api
			.get(`rulesets/campaigns/${campaignIds.join(',')}`)
			.then(({ body }) => {
				Object.keys(body).map((id) => update(id, body[id]));
			})
			.catch((error) => {
				addError(
					commit,
					error,
					`Something went wrong while fetching ruleset data for these campaigns: ${campaignIds.join('\n')}`
				);

				if (1 === campaignIds.length) {
					update(campaignIds.pop(), error, 'object');
				}

				console.error({ error, campaignIds });
			})
			.finally(() => {
				campaignIds.forEach((campaignId) => {
					commit('fetched', `c-rulesets-${campaignId}`, { root: true });
				});

				resolve();
			});
	});
}
